module.exports = __webpack_public_path__ + "static/media/qp-logo-img@2x.100df1ae.png";